function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_898",
  "data-name": "Group 898",
  transform: "translate(-76.169 -232.052)",
  opacity: 0.75
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_469",
  "data-name": "Path 469",
  d: "M66.836-347.74a1.691,1.691,0,0,1,1.231.533,1.69,1.69,0,0,1,.455,1.261L65.9-303.7a6.273,6.273,0,0,1-6.261,5.885H21.364A6.273,6.273,0,0,1,15.1-303.7s-2.108-33.982-2.62-42.246a1.689,1.689,0,0,1,.455-1.261,1.691,1.691,0,0,1,1.231-.533ZM36.271-322.765l-6.82-6.822a3.024,3.024,0,0,1,0-4.275,3.024,3.024,0,0,1,4.276,0l6.82,6.82,6.781-6.781a3.025,3.025,0,0,1,4.276,0,3.024,3.024,0,0,1,0,4.275l-6.781,6.783,6.781,6.781a3.024,3.024,0,0,1,0,4.276,3.025,3.025,0,0,1-4.276,0l-6.781-6.781-6.82,6.82a3.024,3.024,0,0,1-4.276,0,3.024,3.024,0,0,1,0-4.275Z",
  transform: "translate(66.734 601.868)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_470",
  "data-name": "Path 470",
  d: "M23.166-346.375v-2.892a9.786,9.786,0,0,1,2.867-6.919,9.791,9.791,0,0,1,6.92-2.867H50.886a9.791,9.791,0,0,1,6.92,2.867,9.787,9.787,0,0,1,2.866,6.919v2.892H69.9a3.019,3.019,0,0,1,3.018,3.017A3.02,3.02,0,0,1,69.9-340.34H13.937a3.02,3.02,0,0,1-3.018-3.019,3.019,3.019,0,0,1,3.018-3.017Zm31.144,0V-349.5a3.316,3.316,0,0,0-.97-2.344,3.315,3.315,0,0,0-2.342-.97H32.613a3.315,3.315,0,0,0-2.342.97,3.316,3.316,0,0,0-.97,2.344v3.122Z",
  transform: "translate(65.25 591.105)",
  fillRule: "evenodd"
}));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.001,
    height: 72,
    viewBox: "0 0 62.001 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.116babce.svg";
export { ForwardRef as ReactComponent };